import 'remodal'
import Cookies from 'js-cookie'

/*************** Open modal Window ***************/
const inst = $('[data-remodal-id=alert-notice-modal]').remodal({
	hashTracking: true,
	closeOnOutsideClick: true,
})

// In IE 11 the window would get scrolled down to the bottom of the page. This
// happened because the modals would append to the bottom of the body element
// and IE would jump to where the ID for the modal was before the CSS would
// apply to the modal.
$('.remodal-overlay').appendTo('#modal-append-container')
$('.remodal-wrapper').appendTo('#modal-append-container')

/**
 * Opens the modal window
 */
if (!Cookies.get('fub-alert-notice-modal')) {
	if (inst) {
		inst.open()
	}
}

$(document).on('closed', '.alert-notice-modal', function () {
	Cookies.set('fub-alert-notice-modal', 'closed', { expires: 1, path: '/' })
})
